module.exports = __webpack_public_path__ + "img/人像抠图--大图gif.26c302b6.gif";